import React from "react";
import { useReactTable, getCoreRowModel, flexRender } from "@tanstack/react-table";



const ExecutionReportOverview = ({ selectedExecution, isFctw, handleScrollingFilter }) => {
  const columns = [
    {
      header: "Metric",
      accessorKey: "metric",
      cell: (props) => {
        console.log("value:", props.getValue())
        const value = props.getValue();
        if(value === "Pass Percentage" || value === "Execution Error") return (
          <p style={{ wordBreak:"break-all",textAlign:'center',margin:0}}>
            {value}
          </p>
        )
        return (
          <p style={{ wordBreak:"break-all",textAlign:'center', margin:0}}>
            <a onClick={()=>{
              const section = document.getElementById("scenario-details-table-scroll");
              if (section) {
                handleScrollingFilter(value);
                section.scrollIntoView({ behavior: "smooth" });
              }
            }} style={{color:"#0056b3"}}> {props.getValue()}</a>
          </p>
        );
      },
    },
    {
      header: "Mandatory Target",
      accessorKey: "mandatory_target",
    },
    ...(!isFctw? [
      {
        header: "Development Target",
        accessorKey: "development_target",
      }
    ]: [])
  ];

  console.log("EXECUTION REPORT OVERVIEW", selectedExecution);

  const mandatoryTarget = selectedExecution.mandatory_target || {};
  const developmentTarget = selectedExecution.development_target || {};

  const data = [
    {
      metric: "Total",
      mandatory_target: mandatoryTarget.total_variations_executed || 0,
      development_target: developmentTarget.total_variations_executed || 0,
    },
    {
      metric: "Passed",
      mandatory_target: mandatoryTarget.passed || 0,
      development_target: developmentTarget.passed || 0,
    },
    {
      metric: "Failed",
      mandatory_target: mandatoryTarget.failed || 0,
      development_target: developmentTarget.failed || 0,
    },
    {
      metric: "Reporting Error",
      mandatory_target: mandatoryTarget.error || 0,
      development_target: developmentTarget.error || 0,
    },
    {
      metric: "Execution Error",
      mandatory_target: mandatoryTarget.bench_error || 0,
      development_target: developmentTarget.bench_error || 0,
    },
    {
      metric: "Pass Percentage",
      mandatory_target: mandatoryTarget.pass_percentage || 0,
      development_target: developmentTarget.pass_percentage || 0,
    },
  ];

  const table = useReactTable({
    data,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div>
      <table
        style={{
          border: "solid 1px rgba(0,0,0,5)",
          width: "100%",
          borderRadius: "50px",
        }}
      >
        <thead>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => {
                console.log("HEADER", header);
                return (
                  <th
                    key={header.id}
                    colSpan={header.colSpan}
                    style={{
                      borderBottom: "solid 3px rgba(0,0,0,5)",
                      background: "#B0FF45",
                      color: "rgba(0,0,0,1)",
                      fontWeight: "bold",
                      textAlign: "center",
                      padding: "10px",
                      borderRight: "1px solid rgba(0,0,0,5)",
                    }}
                  >
                    {header.isPlaceholder
                      ? null
                      : flexRender(header.column.columnDef.header, header.getContext())}
                  </th>
                );
              })}
            </tr>
          ))}
        </thead>
        <tbody>
          {table.getRowModel().rows.map((row) => (
            <tr key={row.id} style={{ padding: "10px" }}>
              {row.getVisibleCells().map((cell) => (
                <td
                  key={cell.id}
                  style={{
                    padding: "10px",
                    border: "solid 1px gray",
                    textAlign: "center",
                  }}
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ExecutionReportOverview;
